import React, { Component } from "react";
import SpecsIcon from "../assets/icons/specs_icon.svg";
import ResourcesIcon from "../assets/icons/resources_icon.svg";
import FAQIcon from "../assets/icons/FAQ_icon.svg";


class Menu extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="menu-options d-flex align-items-center flex-column">
        <div
          className="menu-btn d-flex"
          id="show-spec"
          data-type="result"
          data-next-page="{{specs.id}}"
          data-transition-video="{{result.transition_video}}"
        >
          <img
            className="menu-icon"
            src={SpecsIcon}
            alt="specs"
            onClick={this.props.showSpecs}
          />
        </div>
        <div className="menu-btn d-flex" id="show-resources">
          <img
            className="menu-icon"
            src={ResourcesIcon}
            alt="resources"
            onClick={this.props.showResources}
          />
        </div>
        <div className="menu-btn d-flex" id="show-faq">
          <img
            className="menu-icon"
            src={FAQIcon}
            alt="faq"
            onClick={this.props.showFAQs}
          />
        </div>
      </div>
    );
  }
}

export default Menu;
